import React from "react";
import CustomModal from "../CustomModal";
import { FaTimes } from "react-icons/fa";

const RenterTermsModal = ({ open, onClose }) => {
  return (
    <CustomModal
      open={open}
      onClose={onClose}
      title="Kitchen Renter Terms and Conditions"
      maxWidth="md"
      showCloseButton={true}
      customStyles={{
        "& .custom-modal-content": {
          width: "60%",
          padding: "10px",
          maxHeight: "80vh",
          overflowY: "auto",
        },
        "@media (max-width: 600px)": {
          "& .custom-modal-content": {
            width: "85%",
            padding: "15px",
          },
        },
      }}
    >
      <div className="kitchen-page-modal-body">
        <p>
          This Rental Agreement and Disclaimer (“Agreement”) is entered into
          between the renter (“Renter”) and AirKitchenz, governing the use of
          kitchens rented through the AirKitchenz platform. By checking the box
          below, the Renter acknowledges and agrees to comply with all terms and
          conditions herein.
        </p>

        <h3>1. Insurance Requirements</h3>
        <p>
          The Renter agrees to maintain adequate insurance coverage for the
          duration of the rental period, including but not limited to liability
          insurance and any other insurance deemed necessary by AirKitchenz. The
          Renter must provide proof of insurance and identification (driver’s
          license or passport) to cover any liability or damage occurring during
          the rental period.
        </p>

        <h3>2. Documentation Requirements</h3>
        <p>
          The Renter is required to upload the following documentation to the
          Platform prior to the commencement of the rental period:
        </p>
        <ul>
          <li>Proof of identity (driver’s license or passport)</li>
          <li>Liability insurance</li>
          <li>Food handler certification</li>
        </ul>
        <p>
          Failure to upload the required documentation may result in
          cancellation of the booking and forfeiture of any deposits paid.
        </p>

        <h3>3. Deposit and Damage Protection</h3>
        <p>
          The Platform will collect a security deposit from the Renter at the
          time of booking. This deposit will be held by the Platform for 66
          hours after the Kitchen booking is finalized. The Renter acknowledges
          that they are solely responsible for any damage to the rented kitchen,
          missing items, or any other issues that occur during the rental
          period.
        </p>
        <p>
          The Kitchen Owner has 66 hours after the booking period ends to report
          any issues or damages to the Kitchen or equipment. If no issues or
          damages are reported within this timeframe, the Platform will return
          the security deposit to the Renter. If any damage, missing items, or
          other costs exceed the deposit, AirKitchenz is authorized to charge
          the Renter’s credit card for the additional amount necessary to cover
          the expenses incurred.
        </p>

        <h3>4. Clean-Up Responsibility and Documentation</h3>
        <p>
          The Renter agrees to leave the rented kitchen in the same condition as
          it was found, including but not limited to cleaning up after use,
          disposing of waste properly, and returning any borrowed items to their
          original location.
        </p>
        <p>
          To ensure the condition of the kitchen is documented, the Renter is
          encouraged to take photographs of the kitchen upon arrival, clearly
          capturing the initial state and condition of the kitchen and its
          equipment. Upon completing the use of the kitchen, the Renter should
          take additional photographs to document the state in which the kitchen
          and all equipment were left.
        </p>
        <p>
          Any disputes regarding the condition of the kitchen or equipment must
          be substantiated with clear photographic evidence taken before and
          after the rental period. AirKitchenz reserves the right to make a
          final decision based on the evidence provided.
        </p>

        <h3>5. Liability and Indemnification</h3>
        <p>
          The Renter agrees that AirKitchenz shall not be held liable for any
          damage, missing items, accidents, or issues that occur during the
          rental period. The Renter further agrees to indemnify and hold
          AirKitchenz harmless from any claims, damages, or liabilities arising
          out of the Renter’s use of the rented kitchen.
        </p>
        <p>
          AirKitchenz acts solely as a facilitator and is not responsible for
          any agreements, actions, or negligence on the part of the kitchen
          owner or the Renter. All liability rests with the respective parties
          involved in the rental agreement.
        </p>

        <h3>6. Platform Facilitation and Transaction Requirements</h3>
        <p>
          The Renter acknowledges and agrees that AirKitchenz does not own any
          of the kitchen locations listed on its platform. AirKitchenz serves
          solely as a facilitator of transactions between the Renter and kitchen
          owners.
        </p>
        <p>
          All transactions, payments, and communications must be conducted
          exclusively through the AirKitchenz platform. No exchange of personal
          contact information, including phone numbers or email addresses, is
          allowed between the Renter and the Kitchen Owner for security reasons.
          Any arrangements made outside of the AirKitchenz platform are strictly
          prohibited.
        </p>

        <h3>7. Credit Card Authorization and Charges</h3>
        <p>
          The Renter authorizes AirKitchenz to keep the credit cards used for
          payment on file. In the event of damage, missing items, or if costs
          exceed the deposit amount, the Renter agrees that AirKitchenz has the
          right to charge the Renter’s credit cards for the additional amount
          necessary to cover the expenses incurred.
        </p>
        <p>
          The Renter understands that this authorization includes charging the
          credit cards for any costs related to damages, missing items, or other
          expenses not covered by the initial security deposit.
        </p>

        <h3>8. Communication Protocol</h3>
        <p>
          The Renter agrees that all communications between the Renter and
          kitchen owners must be conducted exclusively through the AirKitchenz
          platform. Renters and kitchen owners are prohibited from exchanging
          phone numbers, email addresses, or other contact information outside
          of the AirKitchenz platform.
        </p>

        <h3>9. Rating System and Reviews</h3>
        <p>
          AirKitchenz maintains a rating system that allows both kitchen renters
          and kitchen owners to provide feedback and rate each other based on
          their rental experience.
        </p>
        <p>Kitchen Renters will rate the kitchens based on:</p>
        <ul>
          <li>Cleanliness of the kitchen</li>
          <li>Functionality and condition of equipment</li>
          <li>Accuracy of the kitchen listing description</li>
          <li>Overall experience</li>
        </ul>
        <p>Kitchen Owners will rate the Kitchen Renters based on:</p>
        <ul>
          <li>Cleanliness after use</li>
          <li>Adherence to kitchen rules</li>
          <li>Communication and responsiveness</li>
          <li>Respect for the kitchen and equipment</li>
        </ul>

        <h3>10. Enforcement and Penalties</h3>
        <p>
          Any party found to be in violation of the communication protocol will
          be subject to suspension or permanent removal from the AirKitchenz
          platform.
        </p>

        <h3>11. AirKitchenz Service Fee</h3>
        <p>
          AirKitchenz charges a service fee of 15% of the total rental cost for
          facilitating the transaction and providing platform services.
        </p>

        <h3>12. Governing Law</h3>
        <p>
          This Agreement shall be governed by and construed in accordance with
          the laws of the United States and the states where the transactions
          take place.
        </p>

        <h3>13. Entire Agreement</h3>
        <p>
          This Agreement constitutes the entire agreement between the Renter and
          AirKitchenz regarding the rental of the kitchen and supersedes all
          prior agreements and understandings, whether written or oral.
        </p>

        <p>
          By checking the box below, the Renter acknowledges that they have
          read, understood, and agree to be bound by all terms and conditions
          herein. Failure to comply with any provision of this Agreement may
          result in termination of the rental agreement and forfeiture of the
          Renter’s deposit.
        </p>
      </div>
    </CustomModal>
  );
};

export default RenterTermsModal;
